import { http } from "~/utils";
export default {
    
    getNonSodeDashboardReport: async filters => {
        return http.post(`/india/non-sode/non-sode/non-sode-dashboard-report/`, filters)
            .then(response => {
                return response.data
            });
    }   
};
